<template>
  <v-container
    d-flex
    align-content-center
    fill-height
    fluid
    style="height: 100vh"
    class="pt-0"
  >
    <v-row justify="center">
      <v-col cols="12" sm="12" md="auto" class="pa-4" style="max-width: 100%">
        <ingestor-connection-error
          @confirm="$emit('close')"
          @cancel="$emit('close')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import IngestorConnectionError from './Overlay/IngestorConnectionError.vue';

import { mapState } from 'vuex';

export default {
  components: {
    IngestorConnectionError,
  },
  computed: {
    ...mapState({
      authStatus: (state) => state.auth.status,
    }),
  },
};
</script>

<style></style>
